<template>
  <div class="login" style="height: 100%;">
    <p>
      {{ $t("reg.agreementDetail") }}
    </p>
  </div>
</template>


<script>
export default {
  name: 'agreement',
  components: {
  },
  data() {
    return {
      clients: [],
      profile: {},
    }
  },
  computed: {

  },
  beforeMount() {
  },


  methods: {

  },

  watch: {

  }
}
</script>

<style lang="scss" scoped>
.weui-cells__group_form {
  .weui-label {
    max-width: 7em;
  }

  .weui-cell__hd {
    padding-right: 10px;
  }

  .weui-cell {
    padding: 16px;
  }
}
</style>